import { useMemo } from "react";

import { defaultCurveConfig } from "./curve";
import type { BoxedConnector, CurveConfig } from "./types";
import { useCurvableConnectors } from "./useCurvableConnectors";

type Props = {
  boxedConnectors: BoxedConnector[];
  options?: CurveConfig;
  movingSceneId?: number | string;
};

export const useConnectorAnalytics = ({ boxedConnectors, options = defaultCurveConfig, movingSceneId }: Props) => {
  const connectors = useCurvableConnectors({ boxedConnectors, options, movingSceneId });

  return useMemo(
    () =>
      connectors.map(({ id, analyticsState, analyticsLabel, color, curveDescriptor }) => ({
        id,
        state: analyticsState,
        label: analyticsLabel,
        position: curveDescriptor.midpoint,
        color,
      })),
    [connectors],
  );
};
